import CourseGoalsView from './components/goals-view';

export default CourseGoalsView;
